// creating an instance of route history, use for auth
import { createBrowserHistory } from "history";
export default createBrowserHistory();